// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vjKVB","badges":"styles_badges__1Bk6K"};